<template>
	<div>
		<!-- 新增、编辑客房 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="40%" :close-on-click-modal="false"
		  :modal-append-to-body="false" :before-close="handleClose">
			<el-form :model="formData" label-width="100px">
				<el-form-item label="所属单位">
					<el-autocomplete v-model="formData.company" :fetch-suggestions="querySearchAsync" placeholder="请输入内容" value-key="unitName"
					 clearable @clear="clearSearch" ref="myAutocomplete"></el-autocomplete>
				</el-form-item>
				<!-- <el-form-item label="房型">
					<el-select v-model="formData.roomType" placeholder="请选择" clearable @change="changeRoomType">
						<el-option v-for="item in roomTypeArr" :label="item.name" :value="item.name"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="客房面积">
					<el-input v-model="formData.area" placeholder="" clearable></el-input>
				</el-form-item>
				<!-- 	<el-form-item label="客房朝向">
					<el-select v-model="formData.orientations" placeholder="请选择" clearable>
						<el-option label="区域一" value="shanghai"></el-option>
						<el-option label="区域二" value="beijing"></el-option>
					</el-select>
				</el-form-item> -->
				<el-form-item label="具体位置">
					<el-input v-model="formData.address" placeholder="例如:热河南路2号吾悦广场" clearable></el-input>
				</el-form-item>
				<el-form-item label="楼栋">
					<el-input v-model="formData.building" placeholder="例如:A栋" clearable></el-input>
				</el-form-item>
				<el-form-item label="楼层">
					<el-input v-model="formData.storey" placeholder="例如:1楼" clearable></el-input>
				</el-form-item>
				<el-form-item label="房间号">
					<el-input v-model="formData.roomNumber" placeholder="例如:A 101" clearable></el-input>
				</el-form-item>
				<!-- <el-form-item label="套数">
					<el-input v-model.number="formData.setNum" type="number" placeholder="请输入套数" min="0"></el-input>
				</el-form-item> -->
				<el-form-item label="备注">
					<el-input v-model="formData.remarks" placeholder="请输入内容" type="textarea" :rows="10"></el-input>
				</el-form-item>
				<el-form-item label="房型图">
					<el-image style="width: 100px; height: 100px" :src="url" :preview-src-list="formData.showFilePathList">
					</el-image>
				</el-form-item>
				<el-form-item label="水仪表编码">
					<el-input  v-model="formData.waterCode"></el-input>
				</el-form-item>
				<el-form-item label="电仪表编码">
					<el-input  v-model="formData.electricityCode"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelClick">取 消</el-button>
				<el-button type="primary" @click="confirmClick">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		props: ["title", "dialogVisible", "formDataDetail"],
		data() {
			return {
				disabled: false,
				formData: {
					roomNumber: null, //房间号
					company: "", //所属单位
					roomType: null, //房型
					area: null, //面积
					orientations: null, //朝向
					address: null, //具体位置
					building: null, //楼栋
					storey: null, //楼层
					setNum: null, //套数
					remarks: null, //备注
					pictureFilePathList: [], //房型图文件路径
					showFilePathList: [], //预览图片路径,
					waterCode:null,
					electricityCode:null
				},
				formData2: {
					roomNumber: null, //房间号
					company: "", //所属单位
					roomType: null, //房型
					area: null, //面积
					orientations: null, //朝向
					address: null, //具体位置
					building: null, //楼栋
					storey: null, //楼层
					setNum: null, //套数
					remarks: null, //备注
					pictureFilePathList: [], //房型图文件路径
					showFilePathList: [], //预览图片路径,
					waterCode:null,
					electricityCode:null
				},
				roomTypeArr: [], //所有房型图
				url: "",
				srcList: [], //预览图片路径,
			}
		},
		watch: {
			dialogVisible() {
				this.$http("/api/roomManage/getRoomType").then(res => {
					console.log("户型", res);
					this.roomTypeArr = res.data.data;


					if (this.title.indexOf("新增") > -1) {
						this.formData = { ...this.formData2
						};
						// 给el-image添加默认路径
						this.url = this.roomTypeArr[0].showpath;
						this.formData.roomType = this.roomTypeArr[0].name;

						this.formData.showFilePathList = [];
						this.formData.showFilePathList.push(this.url);
						console.log(this.formData);
					} else {
						this.formData = { ...this.formDataDetail
						};
						this.url = this.formData.showFilePathList[0];
						console.log("lllllllll", this.formData);
					}


				});

			}
		},
		methods: {
			// 取消
			cancelClick() {
				this.close();
			},
			// 确定
			confirmClick() {
				let url;
				let params;
				if (this.title.indexOf("新增") > -1) {
					url = "/roomManage/addRoom";
					params = {
						...this.formData,
						createId: null,
					};
				} else {
					url = "/roomManage/modifyRoom";
					params = {
						...this.formData,
					};
				}
				this.addAndModify(url, params);
			},

			// 新增、编辑发请求
			addAndModify(url, params) {
				this.$http.post("/api" + url, params).then(res => {
					console.log("嘿嘿", res);
					this.$message.success(res.data.message);
					this.close();
				})
			},


			// 关闭之前的回调
			handleClose(done) {
				this.close();
			},
			// 关闭模态框向父组件传dialogVisible
			close() {
				this.$emit("changeVisible", {
					dialogVisible: false,
				})
			},
			// 查询所有单位信息
			querySearchAsync(queryString, cb) {
				this.$http.get('/api/ownerManage/getOwners?company=' + this.formData.company).then(res => {
					console.log("查询所有单位信息", res);
					let result = res.data.data;
					cb(result);
				})
			},

			// 解决el-autocomplete使用clearable，失效问题
			clearSearch() {
				this.$refs.myAutocomplete.handleFocus()
			},

			// 选择房型
			changeRoomType(val) {
				// this.srcList = [];
				this.formData.showFilePathList = [];
				let result = this.roomTypeArr.find(item => {
					return val == item.name;
				})
				this.url = result.showpath;
				this.formData.showFilePathList.push(result.showpath);
			},

		}
	}
</script>

<style scoped="scoped">
</style>
